// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useColorScheme } from '@mui/material/styles';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { mode, setMode } = useColorScheme();

  const handleToggleMode = () => {
    setMode(mode === 'dark' ? 'light' : 'dark');
  };

  return (
    <>
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <Tooltip title={mode === 'dark' ? 'Modo claro' : 'Modo escuro'}>
        <IconButton color="inherit" onClick={handleToggleMode} size="small" aria-label={mode === 'dark' ? 'Ativar modo claro' : 'Ativar modo escuro'}>
          <Box component="span" sx={{ fontSize: 20, lineHeight: 1 }}>
            {mode === 'dark' ? '\u2600' : '\u263E'}
          </Box>
        </IconButton>
      </Tooltip>

      <Notification />
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
